<template>
  <div class="main-home">
		<LeftMenu v-if="loadPage" style="z-index: 1000" />

    <transition leave-class="top-loading-bar-leave-class" leave-to-class="top-loading-bar-leave-to-class" leave-active-class="top-loading-bar-leave-active-class">
      <div v-if="showTopLoadingBar" class="top-loading-bar" :style="topLoadingBarStyling"></div>
    </transition>

    <div class="top-nav">
      <img @click="pageClick('')" :src="compLogo" />

      <!-- <div style="font-size: 12px; padding-left: 3px">V {{ version }}</div> -->
      <Tooltip :showIndicator="false" :minWidth="300" class="version" v-if="stateItem.versions.length > 0">
        v{{ stateItem.versions[0] ? stateItem.versions[0]['Version'] || '' : '' }}
        <div slot="tooltip" class="version-tooltip">
          <div v-for="(v, i) in stateItem.versions" :key="i" class="version-container" :class="{ 'border-bottom': i != stateItem.versions.length - 1 }">
            <div>v{{ v['Version'] }} {{ i == 0 ? `(Current)`: '' }}</div>
            <div>{{ v['PublishedDate'] }}</div>
            <div>{{ v['Description'] }}</div>
          </div>
        </div>
      </Tooltip>

      <div class="breadcrumb">
        <div v-for="(i, index) in itemsList" :key="index">
          <div v-if="index > 0 && i">
            <span class="title" :style="{ fontWeight: index == itemsList.length - 1 ? 'bolder' : 'normal' }" @click="navClick(index)">
              <span v-if="index > 1">{{ i }}</span>
              <span v-else>{{ compName }} ({{ branchCode }})</span>
            </span>
            <span class="splitter">/</span>
          </div>
        </div>
      </div>

      <div class="pages">
        <div class="spacer"></div>
        <Input placeholder="Need Help?" :inputValue.sync="searchValue" style="min-width: 250px; max-width: 350px" @focusChanged="searchState" />
        <div v-if="searchLoading || Object.keys(searchResult).length > 0" class="search-result" @mouseenter="searchStayOpen = true" @mouseleave="searchStayOpen = false">
          <div :style="{ padding: searchLoading ? '5px' : '0' }">{{ searchLoading }}</div>
          <!-- All matched 6G pages/links -->
          <div v-if="searchResult['allPages']" class="grouping">Matched 6G Pages {{ searchResult['allPages'] ? `(${searchResult['allPages'].length})` : `` }}</div>
          <div v-if="searchResult['allPages']" class="matched-listing no-interaction" :style="{ display: searchResult['allPages'].length > 0 ? 'none' : '' }">
            <div v-if="searchResult['allPages'].length == 0">No matched 6G pages</div>
          </div>
          <div v-for="(p, pi) in searchResult['allPages']" :key="`page${pi}`" class="matched-listing" @click="resultClicked(p)">
            <div>{{ p['title'] }}</div>
            <img src="https://dsmlib.logistics.systems/Icons/open-in-new-tab.png">
          </div>
          <!-- All matched KB files -->
          <div v-if="searchResult['allFiles']" class="grouping">Matched KnowledgeBase Pages {{ searchResult['allFiles'] ? `(${searchResult['allFiles'].length})` : `` }}</div>
          <div v-if="searchResult['allFiles']" class="matched-listing no-interaction" :style="{ display: searchResult['allFiles'].length > 0 ? 'none' : '' }">
            <div v-if="searchResult['allFiles'].length == 0">No matched KnowledgeBase Pages</div>
          </div>
          <div v-for="(f, fi) in searchResult['allFiles']" :key="`file${fi}`" class="matched-listing" @click="resultClicked(f)">
            <div>{{ f['name'].split('.')[0] }}</div>
            <img src="https://dsmlib.logistics.systems/Icons/open-in-new-tab.png">
          </div>
          <!-- All matched KB contents -->
          <div v-if="searchResult['allContent']" class="grouping">Matched KnowledgeBase Contents {{ searchResult['allContent'] ? `(${searchResult['allContent'].length})` : `` }}</div>
          <div v-if="searchResult['allContent']" class="matched-listing no-interaction" :style="{ display: searchResult['allContent'].length > 0 ? 'none' : '' }">
            <div v-if="searchResult['allContent'].length == 0">No matched KnowledgeBase Contents</div>
          </div>
          <div v-for="(c, ci) in searchResult['allContent']" :key="`content${ci}`" class="matched-listing" @click="resultClicked(c)">
            <div v-html="`${c['value']}<br>in file <b>${c['name'].split('.')[0]}</b>`"></div>
            <img src="https://dsmlib.logistics.systems/Icons/open-in-new-tab.png">
          </div>
        </div>
      </div>
      <img class="help-icon" src="https://dsmlib.logistics.systems/Icons/Help.png" @click="helpClicked" title="Help">
      <div class="dropdown disable-selection" style="height: 100%; margin-left: 10px">
        <div class="profile" id="profileDropdown" data-toggle="dropdown">
          <img src="@/assets/User.png" alt="">
        </div>
        <div class="dropdown-menu" aria-labelledby="profileDropdown">
          <div class="profile-view">
            User : {{ userID }} <br>
            Login : {{ loginTime ? loginTime.formatString('dd/MM/yyyy HH:mm') : '' }} <br>
            Branch : {{ branchCode }} - {{ branchName }} <br>
            Base : {{ base }} <br>
          </div>
          <div class="dropdown-divider"></div>
          <div class="profile-item profile-logout" @click="logoutClick()">Logout</div>
          <div class="dropdown-divider"></div>
          <!-- <Dropdown placeholder="Accounts" :items="loggedinAcc" itemKey="user" :selectedObject.sync="selectedLoggedin" @selected="accountSelect" /> -->
          <div style="margin-left: 5px">Accounts:</div>
          <div class="accounts-container">
            <div v-for="(l, i) in stateItem.loggedInAccounts" :key="i" class="accounts" :class="{ 'disable': l['userKey'] == userParam }" @click="accountSelect(l['userKey'])">
              <div>{{ l['user'] }}</div>
              <div style="font-weight:bold;margin-left:5px">{{ l['userKey'] == userParam ? '(ACTIVE)' : '' }}</div>
            </div>
          </div>
          <button @click="loginClicked">Login To Another Account</button>
          <div class="dropdown-divider"></div>
          <div class="copyright">
            <span>Copyright (c) 2020</span>
          </div>
          <div class="copyright">
            <span>Digital Systems (M) Sdn. Bhd.</span>
          </div>
          <div class="profile-view version">
            <div class="version-details">DSM 6G V {{ stateItem.versions.length > 0 ? (stateItem.versions[0] ? stateItem.versions[0]['Version'] || '' : '') : '' }}</div>
            <button class="report-btn" @click="reportClicked">Report</button>
          </div>
        </div>
      </div>
      <div style="margin-left: 5px">{{ userID }}</div>
    </div>

    <!-- #region Narrow Top Bar -->
    <div class="top-nav-narrow" :style="{ zIndex: breadcrumbOpen ? '1001' : '' }">
      <div v-if="breadcrumbOpen" class="breadcrumb-background" @click="breadcrumbOpen = false"></div>
      <img @click="pageClick('')" :src="compLogo" />
      <div class="version">v{{ stateItem.versions[0] ? stateItem.versions[0]['Version'] || '' : '' }}</div>
      <div class="breadcrumb breadcrumb-narrow">
        <div class="breadcrumb-items" v-for="(i, index) in itemsList" :key="index">
          <div v-if="index > 0 && i">
            <span class="title" :style="{ fontWeight: index == itemsList.length - 1 ? 'bolder' : 'normal' }" @click="navClick(index)">
              <span v-if="index > 1">{{ i }}</span>
              <span v-else>{{ compName }} ({{ branchCode }})</span>
            </span>
            <span class="splitter">/</span>
          </div>
        </div>
        <div class="breadcrumb-button" @click="breadcrumbOpen = !breadcrumbOpen">
          <img src="https://dsmlib.logistics.systems/Icons/icons8-expand-arrow-24.png"
            :style="{ transform: `scaleY(${breadcrumbOpen ? '-1' : '1'})`, transition: '0.3s' }">
        </div>
        <div v-if="breadcrumbOpen" class="hierachy-items">
          <div v-for="(i, index) in itemsList" :key="index" :style="{ display: i ? '' : 'none' }" @click="navClick(index)">
            <div v-if="index > 0 && i">
              <span class="title" :style="{ fontWeight: index == itemsList.length - 1 ? 'bolder' : 'normal' }">
                <span v-if="index > 1">{{ i }}</span>
                <span v-else>{{ compName }} ({{ branchCode }})</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="pages pages-narrow">
        <Input placeholder="🔎Search" :inputValue.sync="searchValue" style="min-width: 250px; max-width: 350px" @focusChanged="searchState" />
        <div v-if="searchLoading || Object.keys(searchResult).length > 0" class="search-result" @mouseenter="searchStayOpen = true" @mouseleave="searchStayOpen = false">
          <div :style="{ padding: searchLoading ? '5px' : '0' }">{{ searchLoading }}</div>
          <!-- All matched 6G pages/links -->
          <div v-if="searchResult['allPages']" class="grouping">Matched 6G Pages {{ searchResult['allPages'] ? `(${searchResult['allPages'].length})` : `` }}</div>
          <div v-if="searchResult['allPages']" class="matched-listing no-interaction" :style="{ display: searchResult['allPages'].length > 0 ? 'none' : '' }">
            <div v-if="searchResult['allPages'].length == 0">No matched 6G pages</div>
          </div>
          <div v-for="(p, pi) in searchResult['allPages']" :key="`page${pi}`" class="matched-listing" @click="resultClicked(p)">
            <div>{{ p['title'] }}</div>
            <img src="https://dsmlib.logistics.systems/Icons/open-in-new-tab.png">
          </div>
          <!-- All matched KB files -->
          <div v-if="searchResult['allFiles']" class="grouping">Matched KnowledgeBase Pages {{ searchResult['allFiles'] ? `(${searchResult['allFiles'].length})` : `` }}</div>
          <div v-if="searchResult['allFiles']" class="matched-listing no-interaction" :style="{ display: searchResult['allFiles'].length > 0 ? 'none' : '' }">
            <div v-if="searchResult['allFiles'].length == 0">No matched KnowledgeBase Pages</div>
          </div>
          <div v-for="(f, fi) in searchResult['allFiles']" :key="`file${fi}`" class="matched-listing" @click="resultClicked(f)">
            <div>{{ f['name'].split('.')[0] }}</div>
            <img src="https://dsmlib.logistics.systems/Icons/open-in-new-tab.png">
          </div>
          <!-- All matched KB contents -->
          <div v-if="searchResult['allContent']" class="grouping">Matched KnowledgeBase Contents {{ searchResult['allContent'] ? `(${searchResult['allContent'].length})` : `` }}</div>
          <div v-if="searchResult['allContent']" class="matched-listing no-interaction" :style="{ display: searchResult['allContent'].length > 0 ? 'none' : '' }">
            <div v-if="searchResult['allContent'].length == 0">No matched KnowledgeBase Contents</div>
          </div>
          <div v-for="(c, ci) in searchResult['allContent']" :key="`content${ci}`" class="matched-listing" @click="resultClicked(c)">
            <div v-html="`${c['value']}<br>in file <b>${c['name'].split('.')[0]}</b>`"></div>
            <img src="https://dsmlib.logistics.systems/Icons/open-in-new-tab.png">
          </div>
        </div>
      </div>
      <img class="help-icon" src="https://dsmlib.logistics.systems/Icons/Help.png" @click="helpClicked" title="Help">
      <div class="dropdown disable-selection" style="height: 100%; margin-left: 10px">
        <div class="profile" id="profileDropdown" data-toggle="dropdown">
          <img src="@/assets/User.png" alt="">
        </div>
        <div class="dropdown-menu" aria-labelledby="profileDropdown">
          <div class="profile-view">
            User : {{ userID }} <br>
            Login : {{ loginTime ? loginTime.formatString('dd/MM/yyyy HH:mm') : '' }} <br>
            Branch : {{ branchCode }} - {{ branchName }} <br>
            Base : {{ base }} <br>
          </div>
          <div class="dropdown-divider"></div>
          <div class="profile-item profile-logout" @click="logoutClick()">Logout</div>
          <div class="dropdown-divider"></div>
          <!-- <Dropdown placeholder="Accounts" :items="loggedinAcc" itemKey="user" :selectedObject.sync="selectedLoggedin" @selected="accountSelect" /> -->
          <div style="margin-left: 5px">Accounts:</div>
          <div class="accounts-container">
            <div v-for="(l, i) in stateItem.loggedInAccounts" :key="i" class="accounts" :class="{ 'disable': l['userKey'] == userParam }" @click="accountSelect(l['userKey'])">
              <div>{{ l['user'] }}</div>
              <div style="font-weight:bold;margin-left:5px">{{ l['userKey'] == userParam ? '(ACTIVE)' : '' }}</div>
            </div>
          </div>
          <button @click="loginClicked">Login To Another Account</button>
          <div class="dropdown-divider"></div>
          <div class="copyright">
            <span>Copyright (c) 2020</span>
          </div>
          <div class="copyright">
            <span>Digital Systems (M) Sdn. Bhd.</span>
          </div>
          <div class="profile-view version">
            <div class="version-details">DSM 6G V {{ stateItem.versions.length > 0 ? (stateItem.versions[0] ? stateItem.versions[0]['Version'] || '' : '') : '' }}</div>
            <button class="report-btn" @click="reportClicked">Report</button>
          </div>
        </div>
      </div>
      <div style="margin-left: 5px">{{ userID }}</div>
    </div>
    <!-- #endregion -->

    <div class="body-home" v-if="!pageAccessDenied" :style="{ backgroundColor: `#${stateItem['backgroundColor']}`, '--main-bg-color': `#${stateItem['backgroundColor']}`  }">
      <router-view v-if="loadPage" class="router"/>
    </div>

    <div class="powered-by-container" ref="poweredByContainer">
      <div class="powered-by" :style="poweredByStyling">
        <div>
          <span>Powered</span>
        </div>
        <div>
          <span>By</span>
          <img id="copyright-logo" src="https://dsmlib.logistics.systems/Icons/Copyright.png" alt="copyright">
        </div>
        <img id="dsm-logo" src="https://dsmlib.logistics.systems/Icons/DSM.GIF" alt="DSM logo">
      </div>
    </div>

    <div class="no-access" v-if="pageAccessDenied" :style="{ backgroundColor: stateItem['backgroundColor'] }">
      <div class="content">
        <div class="prompt">
          <img src="https://dsmlib.logistics.systems/Icons/AccessDenied.png" alt="">
          <div class="message">
            <div class="title">Access Denied</div>
            <div class="content">
              We're sorry but you have no access to <b>{{ pageName }}</b> page.<br>
              Please contact your administrator to get the access.
            </div>
          </div>
        </div>
        <div class="links">
          <button v-if="landingPage" @click="toLandingPageButtonClicked">
            Back to Landing Page
          </button>
          <button @click="toHomePageButtonClicked">
            Back to Home Page
          </button>
        </div>
      </div>
    </div>

    <div class="maintenance" v-if="pageMaintenance">
      <div class="content">
        <div class="image-content">
          <img class="settings" src="https://dsmlib.logistics.systems/Icons/SettingsMove.gif" alt="">
          <img src="https://dsmlib.logistics.systems/Icons/Monitor.png" alt="" style="pointer-events: none">
          <div class="dot" :style="{ backgroundColor: dotColor }" @click="settingsIconClicked"></div>
        </div>
        <div>This page is currently down for maintenance.<br>We're sorry for any inconvenience caused.<br><br>Please contact your administrator for more details.</div>
        <img v-if="maintenanceCanClose" @click="pageMaintenance = false" class="close" src="https://dsmlib.logistics.systems/Icons/Cancel.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';

import LeftMenu from '@/components/LeftMenu.vue';

export default {
  components: {
    LeftMenu
  },
  data: function() {
    return {
      loginTime: null,
      logoutTime: '',

      allVersion: [],
      version: '',

      userID: '',
      branchName: '',
      branchCode: '',
      base: '',
      compLogo: '',
      compName: '',
      config: '',
      landingPage: '',
      loggedinAcc: [],
      selectedLoggedin: null,

      userParam: '',

      loadPage: false,

      showTopLoadingBar: false,
      topLoadingBarWidth: 0, // supposed to be a floating point number, min 0, max 1
      topLoadingBarTimer: null,

      searchValue: '',
      searchResult: {},
      searchLoading: '',
      searchTimeOut: null,
      searchStayOpen: false,

      pageAccessDenied: false,
      pageMaintenance: false,
      maintenanceCanClose: false,
      maintenancePass: '',
      maintenancePassTimer: null,
      dotColor: '',

      poweredByContainerIsHover: false,
      breadcrumbOpen: false,
    }
  },
  props: {
    currentDateTime: { type: String, default: '' },
    second: { type: Number, default: 10 },
    remainingTime: { type: String, default: '00:00' },
    toastShow: { type: Boolean, default: false },
    toastClass: { type: String, default: 'my-toast hide-toast' },
  },
  computed: {
    itemsList: function() {
      return this.$route.path.split('/');
    },
    pageName: function() {
      return this.itemsList[this.itemsList.length - 1];
    },
    topLoadingBarStyling: function() {
      return {
        width: `${this.topLoadingBarWidth * 100}%`
      };
    },
    poweredByStyling: function() {
      return {
        transform: `translateX(${this.poweredByContainerIsHover ? (window.innerHeight < 570 ? '75%' : '-75%') : '0'})`
      }
    },
    stateItem(){
      return this.$store.state ?? {};
    }
  },
  methods: {
    handlePageAccessDenied: function(state) {
      this.pageAccessDenied = state;
    },
    handlePageMaintenance: function(state) {
      this.pageMaintenance = state;
    },
		logoutClick: async function() {
      var logout = await this.$showAlert(
          'warning',
          'Logout',
          'Are you sure you want to logout?',
          [{text : "Logout", color : "red"}, {text : "Cancel"}]
      );

      if (logout == 'Logout') {
        let remainingAccount = this.stateItem.loggedInAccounts.filter(l => l['userKey'] != this.$route.params['user']);

        await this.$apiCallV2('/Login/Logout');
        localStorage.removeItem(this.$route.params['user']);
        this.$store.commit('updateLoggedInAccounts', remainingAccount);

        this.$bus.$emit('userLoggedOut');
			  this.$router.push('/?newUser=1');
      }
    },
    pageClick: function(name) {
      if (name == null) {
        this.toastShow = true;
        return;
      }

      // var initialPath = this.$route.path.split('/');
      // this.$router.push(`/${initialPath[1]}/${this.$route.params['user']}/${name}`);
      this.$router.push(`/Home/${this.$route.params['user']}/${name}`);
    },
    listClick: function(name) {
      this.$router.push(`/HomePage/${name}`);
    },
    navClick: function(i) {
      // var navigate = [];

      // for (var x = 0; x <= i; x++) {
      //   navigate.push(this.itemsList[x]);
      // }

      // const initialPath = this.$route.path.split('/');
      // if (i == 1) {
      //   this.$router.push(`/${initialPath[1]}/${this.$route.params['user']}`);
      // } else if (i == 3) {
      //   this.$router.push(`/${initialPath[1]}/${this.$route.params['user']}`);
      // } else if ( this.itemsList[4] == "ProfileMaster" || this.itemsList[4] == "OperationMaster") {
      //   this.$router.push(`/${initialPath[1]}/${this.$route.params['user']}`);
      // } else {
      //   this.$router.push(navigate.join('/'));
      // }

      if (i !== this.itemsList.length - 1) { // if current page wasn't clicked on
        this.$router.push(`/${this.itemsList[1]}/${this.$route.params['user']}`); // go back to home page, as there are no 2nd level pages currently
      }

      this.breadcrumbOpen = false;
    },
    reportClicked: function() {
      this.$showAlert('info', 'Work in Progress', 'This report function is still under development');
    },
    loginClicked: function() {
      let route = this.$router.resolve('/?newUser=1');
      window.open(route.href, '_blank');
    },
    
    searchingStart: async function(text) {
      const result = await Axios.get(`/KnowledgeBase/SearchKnowledgeBase?search=${text}`);
      if (this._isDestroyed) return;
      this.searchResult = result.data;
      this.searchLoading = '';

      let allMenus = this.$subMenu.getMenus();
      let pages = [];
      allMenus.forEach(m => {
        let allKeys = Object.keys(m['items']);
        allKeys.forEach(k => {
          if (Array.isArray(m['items'][k])) {
            m['items'][k].forEach(i => {
              if (i['title'].toLowerCase().includes(text)) {
                pages.push({
                  title: `${m['title']} - ${i['title']}`,
                  details: i
                });
              }
            });
          } else {
            if (m['items'][k]['title'].toLowerCase().includes(text)) {
              pages.push({
                title: `${m['title']} - ${m['items'][k]['title']}`,
                details: m['items'][k]
              });
            }
          }
        });
      });
      this.searchResult['allPages'] = pages;
    },
    searchState: function(e) {
      if (e && this.searchValue) {
        this.searchLoading = `Searching ${this.searchValue}`;
        this.searchResult = {};
        this.searchingStart(this.searchValue);
      } else if (!this.searchStayOpen) {
        this.searchResult = {};
      }
    },
    resultClicked: function(item) {
      let path = this.$route.path.split('/');
      let route = '';
      if (item['details']) {
        route = this.$router.resolve(`/${path[1]}/${path[2]}${item['details']['route']}`);
      } else {
        route = this.$router.resolve(`/${path[1]}/${path[2]}/KnowledgeBase?dir=${item['directory']}&file=${item['name'].split('.')[0]}&search=${this.searchValue}`);
      }

      window.open(route.href, '_blank');
      this.searchResult = {};
    },

    accountSelect: function(e) {
      if (e == this.$route.params['user']) { return } // if user clicked on the currently active account, don't do anything

      const oriPath = this.$route.fullPath;
      let newRoute;
      if (oriPath.includes(`/${this.userParam}/`)) { // most of the time, it will hit this
        newRoute = this.$router.resolve(oriPath.replace(`/${this.userParam}/`, `/${e}/`));
      } else { // to cater for cases like "/Home/u0" where there's no slash after the user param
        newRoute = this.$router.resolve(oriPath.replace(`/${this.userParam}`, `/${e}`));
      }

      window.open(newRoute.href, '_blank');
    },

    toLandingPageButtonClicked: function(pointerEvent) {
      if (this.landingPage.startsWith("/")) {
        this.$router.push(`/Home/${this.userParam}${this.landingPage}`);
      } else {
        this.$router.push(`/Home/${this.userParam}/${this.landingPage}`);
      }
    },
    toHomePageButtonClicked: function(pointerEvent) {
      this.$router.push(`/Home/${this.userParam}`);
    },

    passEnter: function(e) {
      if (e.key.length > 1) {
        return;
      }

      this.maintenancePass += e.key;
      this.dotColor = 'yellow';

      if (this.maintenancePass.length == 8 && this.maintenancePass == 'Digitals') {
        this.maintenancePass = '';
        this.dotColor = 'green';
        this.pageMaintenance = false;
        document.removeEventListener('keydown', this.passEnter);
      } else if (this.maintenancePass.length > 8) {
        document.removeEventListener('keydown', this.passEnter);
        this.maintenancePass = '';
        this.dotColor = 'red';

        clearTimeout(this.maintenancePassTimer);
        this.maintenancePassTimer = setTimeout(() => {
          this.dotColor = '';
        }, 1000);
      }
    },

    settingsIconClicked: function() {
      document.addEventListener('keydown', this.passEnter);
      this.dotColor = 'gray';
    },

    helpClicked: function() {
      let link = this.$router.resolve(`/Home/${this.$route.params['user']}/KnowledgeBase`);
      window.open(link.href, '_blank');
    },

    updateTopLoadingBarWidth: function(progressDecimal) {
      clearTimeout(this.topLoadingBarTimer);
      this.topLoadingBarWidth = progressDecimal;
      if (progressDecimal !== 1) {
        this.showTopLoadingBar = true;
      } else {
        this.topLoadingBarTimer = setTimeout(() => {
          this.showTopLoadingBar = false; // the width transition of the top loading bar takes 0.5s
        }, 500); // delay hiding the top loading bar by 0.5s to let the width transition finish first
      }
    },

    mouseMoveEvent: function(e) {
      let rect = this.$refs['poweredByContainer'].getBoundingClientRect();
      let containerX = rect['x'];
      let containerY = rect['y'];
      
      if (window.innerHeight < 570) {
        if (e.clientX >= containerX && e.clientY >= containerY) {
          this.poweredByContainerIsHover = true;
        } else {
          this.poweredByContainerIsHover = false;
        }
      } else {
        if (e.clientX <= (containerX + rect.width) && e.clientY >= containerY) {
          this.poweredByContainerIsHover = true;
        } else {
          this.poweredByContainerIsHover = false;
        }
      }
    },
	},
  async mounted() {
    this.maintenanceCanClose = process.env.NODE_ENV == 'development';
    this.$bus.$on('pageAccessDenied', this.handlePageAccessDenied);
    this.$bus.$on('pageMaintenance', this.handlePageMaintenance);
    
		this.userParam = this.$route.params['user'];
    var loginDetails = await this.$apiCallV2('/Login/GetDetails');
    if (this._isDestroyed) return;
    if (loginDetails) {
      this.loadPage = true;
      
      this.loginTime = loginDetails.LoginTime.toDate();
      this.userID = loginDetails.LoginUserId;
      this.branchName = loginDetails.Branch.BrName;
      this.branchCode = loginDetails.Branch.BrCode;
      this.base = loginDetails.BaseName;
      this.compLogo = loginDetails.CoLogo;
      this.compName = loginDetails.CoRefname;
      this.config = loginDetails.ConfigCode;
      this.landingPage = loginDetails.LandingPage;

      let localKeys = Object.keys(localStorage);
      let users = localKeys.filter(l => l.match(/^u[0-9]/));
      let accounts = await this.$apiCallV2('/Login/GetLoggedInDetails', users.map(u => {
        return {
          key: u,
          hash: localStorage.getItem(u)
        }
      }));
      if (this._isDestroyed) return;
      this.$store.commit('updateLoggedInAccounts', accounts);
    } else {
      if (this.userParam) {
        localStorage.removeItem(this.userParam);
      }
      this.$router.push('/');
    }

    this.$bus.$on('topLoading', this.updateTopLoadingBarWidth);
    window.addEventListener('mousemove', this.mouseMoveEvent);
  },
  beforeDestroy() {
    this.$bus.$off('pageAccessDenied', this.handlePageAccessDenied);
    this.$bus.$off('pageMaintenance', this.handlePageMaintenance);
    this.$bus.$off('topLoading', this.updateTopLoadingBarWidth);
    document.removeEventListener('keydown', this.passEnter);
    window.removeEventListener('mousemove', this.mouseMoveEvent);
    clearTimeout(this.topLoadingBarTimer);
    clearTimeout(this.searchTimeOut);
    clearTimeout(this.maintenancePassTimer);
  },
  watch: {
    searchValue: function(val) {
      if (!val) {
        this.searchLoading = '';
        this.searchResult = {};
        clearTimeout(this.searchTimeOut);
        return;
      }

      this.searchLoading = `Searching ${val}`;
      this.searchResult = {};
      clearTimeout(this.searchTimeOut);

      this.searchTimeOut = setTimeout(() => {
        this.searchingStart(val);
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.main-home {
  width: 100%;
  height: 100%;
  z-index: -10;
  // background-color: yellow;

  > .no-access {
    position: fixed;
    left: 0;
    top: 50px;
    height: calc(100% - 50px);
    width: calc(100%);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    > .content {
      background-color: white;
      padding: 10px;
      box-shadow: 5px 5px 5px gray;
      display: flex;
      flex-direction: column;
      max-width: 400px;

      > .prompt {
        display: flex;
        flex-direction: row;

        > img {
          object-fit: contain;
          margin-right: 10px;
        }

        > .message {
          width: 100%;
          display: flex;
          flex-direction: column;

          > .title {
            font-size: 1.5em;
            font-weight: bold;
            margin-bottom: 10px;
          }
        }
      }

      > .links {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
      }
    }
  }

  > .maintenance {
    position: fixed;
    top: 50px;
    left: 0;
    background-color: rgba(128,128,128,0.5);
    height: calc(100% - 50px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    > .content {
      background-color: white;
      padding: 10px;
      border-radius: 5px;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      text-align: center;
      font-size: 12px;

      > .image-content {
        height: 150px;
        width: 150px;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        
        > img {
          position: absolute;
          height: 100%;
          object-fit: contain;
        }

        > .settings {
          height: 40%;
          transform: translateY(-15px);
        }

        > .dot {
          height: 8px;
          width: 8px;
          border-radius: 100%;
          background-color: white;
          position: absolute;
          -webkit-transform: translateY(20px);
          transform: translateY(25px);
        }
      }

      > .close {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        height: 20px;
      }
    }
  }
}

.top-loading-bar {
  position: absolute;
  z-index: 1000;
  height: 8px;
  transition: width 0.5s ease;

  background: linear-gradient(to right, rgb(66, 136, 221) 35%, rgb(220, 220, 220) 50%, rgb(66, 136, 221) 65%);
  background-size: 50%;
  animation: moving-gradient 2s linear infinite;
}
@keyframes moving-gradient { // adapted from https://stackoverflow.com/q/10305596
  0% {
    background-position: left;
  }

  100% {
    background-position: right;
  }
}

.top-loading-bar-leave-class {
  opacity: 1;
}
.top-loading-bar-leave-to-class {
  opacity: 0;
}
.top-loading-bar-leave-active-class {
  transition: opacity 1s ease;
}

.top-nav, .top-nav-narrow {
  &::before{
    content: '';
    //this is for the LeftMenu button
    width: 40px; //button width
    margin-left: -10px; //topnav padding
    height: 100%;
    margin-right: 8px;
  }
  display: flex;
  width: 100%;
  margin-left: auto;
  height: $top-nav-height;
  background-color: white;
  padding: 10px;
  align-items: center;
	box-shadow: 0px -11px 10px 12px #696969;
	z-index: 999;
  font-size: 12px;
  position: relative;

  > img {
    height: 80%;
    transition: 0.15s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.2);
    }
  }

  > .version {
    font-size: 12px;
    margin-left: 10px;
  }
}

.breadcrumb-background {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1001;
}

.version-tooltip {
  > .version-container {
    padding: 10px;
    white-space: pre-wrap;
  }

  > .border-bottom {
    border-bottom: 1px solid rgb(180,180,180);
  }
}

.body-home {
  position: relative;
  height: calc(100% - #{$top-nav-height});
  width: 100%;
  z-index: -1;
  display: flex;
  overflow: auto;
  flex-direction: column;
  // padding: 10px;
  position: absolute;
}

.link-list button {
  margin: 10px;
}

.hide {
  opacity: 0;
}

.body-home .router {
  position: absolute;
  // background-color: green;
  height: 100%;
  width: 100%;
}

.pages {
	// background-color: blue;
	flex-grow: 1;
	height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;

  > .spacer {
    width: 100%;
  }
  
  > .search-result {
    border-style: solid;
    border-color: rgba(128,128,128,0.5);
    border-width: 0 1px 1px 1px;
    background-color: white;
    width: 100%;
    position: absolute;
    top: calc(100% - 6px);
    max-width: 350px;
    min-width: 250px;
    max-height: 450px;
    overflow: auto;

    > .grouping {
      border-bottom: 1px solid gray;
      padding: 5px;
      background-color: gray;
      color: white;
    }

    > .matched-listing {
      padding: 5px;
      padding-left: 15px;
      border-bottom: 1px solid gray;
      cursor: pointer;
      display: flex;
      align-items: center;

      > div {
        width: 100%;
      }

      > img {
        height: 20px;
        width: 20px;
      }

      &:hover {
        background-color: lightgray;
      }
    }

    > .no-interaction {
      cursor: default;

      &:hover {
        background-color: transparent;
      }
    }
  }
}

.page-name {
  margin: 0 10px;
  transition: 0.3s;
}

.page-name:hover {
  transform: scale(1.2);
  cursor: pointer;
}

.profile {
  display: flex;
  align-items: center;
  justify-content: center;
	height: 100%;
  width: calc(#{$top-nav-height} - 20px);
  background-color: white;
  border-radius: 100%;
  border: 1px solid black;
  overflow: hidden;
}

.profile img {
  height: 100%;
  width: 100%;
}

.profile:hover {
  cursor: pointer;
}

.profile-item {
  padding: 8px 10px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 12px;
}

.copyright {
  padding: 0 10px 0 10px;
  font-size: 10px;
}

.profile-view {
  padding: 8px 10px;
  font-size: 11px;
}

.version {
  display: flex;
  align-items: center;
}

.version-details {
  width: 100%;
}

.profile-logout {
  color: black;
  background-color: rgb(255, 139, 139);
  text-align: center;
}

.profile-item:hover {
  cursor: pointer;
  color: white;
  background-color: rgb(255, 64, 64);
}

.dropdown-menu {
  width: 260px;
  transform: translate3d(-225px, 30px, 0px);
  font-size: 12px;

  > button {
    width: calc(100% - 10px);
    padding: 10px;
    margin: 5px;
  }

  > .accounts-container {
    max-height: 250px;
    overflow: scroll;
    
    > .accounts {
      border: 1px solid gray;
      margin: 0 0 5px 5px;
      width: calc(100% - 10px);
      padding: 5px;
      display: flex;
      cursor: pointer;

      &:not(.disable):hover {
        background-color: rgba(200,200,200,0.5);
      }
    }

    > .disable {
      cursor: default;
    }
  }
}

.report-btn {
  background-color: lightgray;

  &:hover {
    background-color: rgb(114, 114, 114) !important;
    color: white !important;
  }
}

// Region Toast
.my-toast {
  position: fixed;
  background-color: white;
  height: 175px;
  width: 200px;
  right: 10px;
  top: 110px;
  overflow: hidden;
  border-radius: 10px;
  border: 2px solid black;
  z-index: 999;
  transition: $transition-time;
}

.hide-toast {
  z-index: -999;
  opacity: 0;
  transform: translateX(200px);
}

.my-toast button {
  border: 1px solid black;
  border-radius: 5px;
  margin: 3px;
}

.my-toast .btn-no {
  background-color: red;
}

.my-toast .btn-extend {
  background-color: greenyellow;
}

.my-toast .header {
  display: flex;
  align-items: center;
	box-shadow: 0 3px 8px -2px black;
  // background-color: aqua;
  padding: 10px;
  height: 35px;
}

.my-toast .body {
  // background-color: greenyellow;
  height: calc(100% - 35px);
  padding: 10px;
  font-size: 12px;
}
// End Region Toast

.breadcrumb {
  font-size: 12px;
  padding: 5px;
  padding-right: 10px;
  margin: 0;
  margin-left: 10px;
  position: relative;
  background-color: #e9ecef;
  z-index: 1002;

  > .hierachy-items {
    position: absolute;
    // background-color: #e9ecef;
    background-color: lightgray;
    padding: 5px;
    top: 100%;
    left: 0;
    padding-top: 0;

    > * {
      background-color: #e9ecef;
      padding: 5px;
      white-space: nowrap;

      &:not(:first-child) {
        margin-top: 5px;
      }
    }
  }
}

.breadcrumb-narrow {
  max-width: fit-content;
  padding-right: 5px;
  cursor: pointer;
}

.breadcrumb .title {
  margin-left: 3px;
  cursor: pointer;
}

.breadcrumb .splitter {
  margin: 0 3px;
}

.powered-by-container {

display: none;

  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999;
  width: fit-content;
  padding: 3px;
  pointer-events: none;
  
  > .powered-by {
    position: relative;
    // position: absolute;
    background-color: white;
    padding: 3px;
    border: 1px solid gray;
    box-shadow: 0 0 10px gray;
    font-size: 7px;
    text-align: center;
    transition: 0.3s;
    width: fit-content;
    pointer-events: none;

    #copyright-logo {
      margin-left: 3px;
      height: 8px;
    }

    > #dsm-logo {
      height: 18px;
    }
  }
}

@media screen and (max-height: 570px) {
  .powered-by-container {
    left: unset;
    right: 0;
  }
}

@media screen and (max-width: 950px) {
  .top-nav {
    display: none;
  }

  .breadcrumb-items {
    display: none;
  }
}

@media screen and (min-width: 950px) {
  .top-nav-narrow {
    display: none;
  }
}

@media screen and (max-width: 550px) {
  .pages-narrow {
    display: none;
  }
}
</style>
